'use client';

import { DayPicker, DayPickerProps } from 'react-day-picker';
import * as styles from './ReactDayPickerStyles.css';

export const DatePicker = (props: DayPickerProps) => {
  return (
    <div className={styles.rdp}>
      <DayPicker weekStartsOn={1} {...props} />
    </div>
  );
};
